/** -- external -- */
import React from "react";

/** -- internal -- */
import { PROJECT_TYPE_LABEL_MAP_V2 } from "Projects/modules/ProjectModules";
import { useI18n } from "Hooks";
import {
  getIconComponent,
  stylesV2 as projectGroupIconStyles,
} from "Courses/components/components/GroupedProjectGroupList/GroupedProjectGroupList";

/** -- relative -- */
import { ModuleCard } from "GlobalHeader/components/JumpToFeature/commonComponents";

const iconProps = { height: 40, width: 40 };

const ProjectsCard = props => {
  const {
    testId,
    projectGroupType,
    onCardClick,
    shortcutKey,
    shiftKey,
    columnIndex,
  } = props;

  const { t } = useI18n(["project"]);
  const localTestId = `${testId}-projectsCard-${projectGroupType}`;

  return (
    <ModuleCard
      columnIndex={columnIndex}
      testId={localTestId}
      icon={getIconComponent({
        projectGroupType,
        iconProps,
      })}
      iconStyle={
        projectGroupIconStyles[projectGroupType] ||
        projectGroupIconStyles.defaultStyle
      }
      label={t(PROJECT_TYPE_LABEL_MAP_V2[projectGroupType])}
      onCardClick={onCardClick}
      shortcutKey={shortcutKey}
      shiftKey={shiftKey}
    />
  );
};

export default ProjectsCard;
